module.exports = {
  env: "production",
  api: process.env.API_URL || "https://api.zavarchitects.com/api/v1.0.0",
};
